module.exports = require('./helpers/bundle-url').getBundleURL('7A20Q') + "logo-dark.eefe0b7f.svg";